
import { initializeApp } from 'firebase/app';
import { getAuth } from 'firebase/auth';
import { getFirestore } from 'firebase/firestore';
// Import other services as needed

const firebaseConfig = {
    apiKey: process.env.REACT_APP_FIREBASE_TOKEN,
    authDomain: "wheresmybar.firebaseapp.com",
    projectId: "wheresmybar",
    storageBucket: "wheresmybar.appspot.com",
    messagingSenderId: "945479766288",
    appId: "1:945479766288:web:b193bf97cac03a82615595",
    measurementId: "G-RCR1Y05R7P"
};

const app = initializeApp(firebaseConfig);
const auth = getAuth(app);
const db = getFirestore(app);
// Initialize other services

export { app, auth, db }; // Export other services